<template>
  <div style="display: inline-block;" :class="margin">
    <v-tooltip :bottom="bottom && !top" :top="top" :disabled="!tooltipText" :color="colorForTooltip">
    <template #activator="{on}">
      <v-icon
        ref="vIcon"
        :tabindex="tabindex"
        :data-testid="dataTestId"
        :disabled="disabled" v-on="on"
        :style="`cursor: ${clickable ? 'pointer' : 'default'}`"
        :large="large"
        :small="small"
        :x-large="xLarge"
        :color="colorForIcon"
        @click="iconClicked"
        @keydown.enter="iconClicked"
        :id="elementId">
        {{ getIcon }}
      </v-icon>
    </template>
    <span :class="getTooltipClass">{{ tooltipText }}</span>
  </v-tooltip>
  </div>
</template>

<script>
import IconHelpers from '@/utils/IconHelpers'
import * as svgLibrary from '@/images/AngelSvgLibrary'
import { camelCase } from 'lodash'

export default {
  name: 'Icon',

  props: {
    tooltipText: { type: String, default: undefined },
    tooltipColor: { type: String, default: undefined },
    tooltipClass: { type: String, default: '' },
    iconColor: { type: String, default: undefined },
    small: { type: Boolean, default: true },
    icon: { type: String, default: 'mdi-exclamation' },
    margin: { type: String, default: 'mr-1' },
    large: { type: Boolean, default: false },
    xLarge: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    dataTestId: { type: String, default: '' },
    propagateClick: { type: Boolean, default: false },
    elementId: { type: String, default: undefined },
    tabindex: { type: String, default: '-1' },
    bottom: { type: Boolean, default: true },
    top: { type: Boolean, default: false },
    overrideClickable: { type: Boolean, default: false }
  },

  computed: {
    clickable () {
      return this.$listeners['icon-clicked'] !== undefined && !this.disabled && !this.overrideClickable
    },

    colorForIcon () {
      if (this.iconColor) return this.iconColor
      return IconHelpers.getColorForIcon(this.icon)
    },

    colorForTooltip () {
      if (this.tooltipColor) return this.tooltipColor
      return ['white', 'tertiary'].includes(this.colorForIcon) ? 'primary' : this.colorForIcon
    },

    getIcon () { // Convention is for the icon prop to be kebab case, but names in the svg library to be camel case
      return svgLibrary[camelCase(this.icon)]?.path ?? this.icon
    },

    getTooltipClass () {
      return 'subtitle-1 white--text icon-tooltip'.concat(` ${this.tooltipClass}`)
    }
  },

  methods: {
    iconClicked (event) {
      if (!this.propagateClick) {
        event.stopImmediatePropagation()
      }
      this.$emit('icon-clicked', event)
      event.target.blur()
    }
  }
}
</script>

<style scoped>
.icon-tooltip {
  white-space: pre-line;
  word-wrap: break-word;
}
</style>
